const LABEL_STYLES = {
  'Strong Match': 'bg-green-100 text-green-700 border-green-200',
  'Good Fit': 'bg-blue-100 text-blue-700 border-blue-200',
  'Possible Fit': 'bg-yellow-100 text-yellow-700 border-yellow-200',
  'Low Fit': 'bg-gray-100 text-gray-500 border-gray-200',
};

const SCORE_BAR_COLORS = {
  'Strong Match': 'bg-green-500',
  'Good Fit': 'bg-blue-500',
  'Possible Fit': 'bg-yellow-500',
  'Low Fit': 'bg-gray-300',
};

export default function MatchScoreCard({ match, onViewCompany, onBuildPitch }) {
  const trendMod = match.trend_modifier || 0;

  return (
    <div style={{
      background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(24px)',
      border: '1px solid #E2E8F0', borderRadius: 20,
      boxShadow: '0 8px 32px rgba(0,0,0,0.08)', padding: 24,
      transition: 'box-shadow 0.2s',
    }}>
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          {match.company_logo ? (
            <img src={match.company_logo} alt="" className="w-10 h-10 rounded-lg object-cover" />
          ) : (
            <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center text-vault-navy font-bold text-sm">
              {match.company_name?.charAt(0)}
            </div>
          )}
          <div>
            <h3 style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, color: '#0F172A', fontSize: 15, margin: 0 }}>
              {match.company_name}
            </h3>
            {match.company_description && (
              <p className="text-xs text-gray-400 line-clamp-1 mt-0.5">{match.company_description}</p>
            )}
          </div>
        </div>
        <span className={`px-2.5 py-1 rounded-full text-xs font-semibold border ${LABEL_STYLES[match.score_label] || LABEL_STYLES['Low Fit']}`}>
          {match.score_label}
        </span>
      </div>

      {/* Score bar */}
      <div className="mb-3">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs text-gray-400">Match Score</span>
          <div className="flex items-center gap-2">
            {match.base_score != null && (
              <span className="text-xs text-gray-400">Base: {match.base_score}</span>
            )}
            {trendMod !== 0 && (
              <span className={`text-xs font-bold ${trendMod > 0 ? 'text-green-600' : 'text-red-500'}`}>
                {trendMod > 0 ? '+' : ''}{trendMod} trend
              </span>
            )}
            <span className="text-sm font-bold text-vault-navy">{match.score}/100</span>
          </div>
        </div>
        <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all ${SCORE_BAR_COLORS[match.score_label] || 'bg-gray-300'}`}
            style={{ width: `${match.score}%` }}
          />
        </div>
      </div>

      {/* Explanation */}
      <p className="text-sm text-gray-600 mb-3" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: 1.6 }}>
        {match.explanation}
      </p>

      {/* Trend impact */}
      {match.trend_reasoning && (
        <div style={{
          padding: 12, borderRadius: 12, marginBottom: 16,
          background: trendMod > 0 ? '#F0FDF4' : trendMod < 0 ? '#FEF2F2' : '#F8FAFC',
          border: `1px solid ${trendMod > 0 ? '#BBF7D0' : trendMod < 0 ? '#FECACA' : '#E2E8F0'}`,
        }}>
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-semibold" style={{ color: trendMod > 0 ? '#16A34A' : trendMod < 0 ? '#DC2626' : '#64748B' }}>
              {trendMod > 0 ? '📈 Trend Boost' : trendMod < 0 ? '📉 Trend Drag' : '➡️ No Trend Impact'}
              {match.trending_topic && ` — ${match.trending_topic}`}
            </span>
          </div>
          <p className="text-xs" style={{ color: trendMod > 0 ? '#15803D' : trendMod < 0 ? '#B91C1C' : '#64748B', lineHeight: 1.5 }}>
            {match.trend_reasoning}
          </p>
        </div>
      )}

      {/* Actions */}
      <div className="flex gap-2">
        <button
          onClick={() => onBuildPitch?.(match)}
          style={{
            flex: 1, padding: '10px 20px', borderRadius: 14,
            background: '#c9a84c', color: 'white', fontSize: 14, fontWeight: 600,
            fontFamily: 'Poppins, sans-serif', border: 'none', cursor: 'pointer',
          }}
        >
          Build Pitch
        </button>
        <button
          onClick={() => onViewCompany?.(match)}
          style={{
            padding: '10px 16px', borderRadius: 14,
            background: 'transparent', color: '#0F172A', fontSize: 14, fontWeight: 600,
            fontFamily: 'Poppins, sans-serif', border: '2px solid #E2E8F0', cursor: 'pointer',
          }}
        >
          Details
        </button>
      </div>
    </div>
  );
}
